import {
    DEALERADDEDITUSERMASTER_SUCCESS,
    DEALERADDEDITUSERMASTER_FAILED,
    RESET_DEALERADDEDITUSERMASTER,
    LOADING_DEALERADDEDITUSERMASTER,
    NETWORK_ERROR_DEALERADDEDITUSERMASTER
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerAddEditUserMaster = () => {
    return { type: RESET_DEALERADDEDITUSERMASTER };
};

const dealerAddEditUserMaster = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDEDITUSERMASTER });
    await dealerServices
        .post("addUpdateUser", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddEditUserMastersuccess(res.data));
                    break;
                default:
                    dispatch(dealerAddEditUserMasterFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDEDITUSERMASTER,
                payload: err
            });
        });
};
function dealerAddEditUserMastersuccess(data) {
    return {
        type: DEALERADDEDITUSERMASTER_SUCCESS,
        payload: data
    };
}
function dealerAddEditUserMasterFailed(data) {
    return {
        type: DEALERADDEDITUSERMASTER_FAILED,
        payload: data
    };
}

export { resetDealerAddEditUserMaster, dealerAddEditUserMaster };
